import React, { useEffect, useState, useRef, useImperativeHandle,forwardRef } from "react";
import * as TUI from "../../index";
import getDownLoadUrl from "./getDownLoadUrl";
import request from "../../utils/request";
import { formatReq, formatRes } from "./format.js";
import "./Crud.less";
import { AuthButton } from "../AuthButton";
import useCrudController from "../../hooks/useCrudController";
import {
  getDefaultFields,
  getFormSchema,
  getFilterSchema,
  getRelatedOptionField,
  getRelatedSchemaTrigger,
  getComputedField,
  getComputed,
  getFiltedSchema,
  getOptions,
  getListSchema,
  addComponent,
  getComponent,
  removeValueOnOptionChanged,
  useFirstOption,
} from "./schemahelper";
import { addRule, getRule } from "./rule"; 
import { addReqTransformer, addResTransformer, getReqTransformer, getResTransformer } from "./format.js";
import NullWhenNoChildren from "../NullWhenNoChildren";
export { getComponent, addComponent } from "./schemahelper";
const Button = AuthButton();
const { Crud, message, Modal } = TUI;
// shcmea view list: 列表， form： 表单 filter:过滤 可叠加
const defaultSchema = [
  {
    field: "field1",
    name: "字段1",
    view: ["list", "form"],
    type: "DatePicker",
    rules: ["required"],
    placeholder: "",
  },
  {
    field: "field2",
    name: "字段2",
    view: ["list", "form", "filter"],
    optionApi: "/api/test/option/field2",
    optionTrigger: ["onChange:field1", "onFilterMount", "onFormMount"],
    type: "Select",
    rules: ["required", "number"],
    placeholder: "",
    listRender: ({ record }) => {
      return record.field1 + "/";
    },
  },
];
const AdvancedCrudCom = ({
  schema = defaultSchema,
  api = {},
  auth = {},
  rowKey = "id",
  defaultService = {},
  modalWrapClassName,
  hookBeforeAdd,
  showColumnAction = true,
  Table,
  Form,
  Modal,
  Filter,
  children,
  onFormStateChange,
  modalProps,
  ...rest
}, ref) => {
  const [formSchema, setFormSchema] = useState(
    getFormSchema(schema, [], false)
  );
  const [formOptions, setFormOptions] = useState({});
  const [filterOptions, setFilterOptions] = useState({});
  const [formMode, setFormMode] = useState("");
  const formOptionsRef = useRef();
  formOptionsRef.current = formOptions;
  const modalTitle = {
    add: "新增",
    edit: "编辑",
    detail: "详情",
  }[formMode];
  const modalFooter = {
    add: undefined,
    edit: undefined,
    detail: null,
  }[formMode];
  const service = {
    ...defaultService,
    list: async ({ query, pagination }) => {
      const task = request(api.list, {
        ...formatReq(query, schema, "filter"),
        pageIndex: pagination.current || 1,
        pageCount: pagination.pageSize || 10,
      });
      let res = await task;
      return res;
    },
    submit: async (params) => {
      if (params.id) {
        return request(typeof api.edit === "object" ? api.edit.url : api.edit, formatReq(params, schema, "form"), schema).catch(
          (e) => {
            message.error(e.message);
            throw e;
          }
        );
      } else {
        return request(typeof api.add === "object" ? api.add.url : api.add, formatReq(params, schema, "form"), schema).catch(
          (e) => {
            message.error(e.message);
            throw e;
          }
        );
      }
    },
    doHandleItemById: async (params) => {
      const task = request(typeof api.remove === "object" ? api.remove.url : api.remove, {
        id: params.id,
      });
      const res = await task;
      if (res.status != 0) {
        message.error(res.message);
      }
    },
    query: async (url, params) => {
      const task = request(url, params);
      const res = await task;
      if (res.status != 0) {
        message.error(res.message);
        throw res;
      }
      return res;
    },
  };
  const filterSchema = getFilterSchema(schema, filterOptions);
  const columns = getListSchema(
    schema,
    api,
    auth,
    setFormSchema,
    formOptions,
    filterOptions,
    showColumnAction
  );
  let crud = useCrudController({
    ListSchema: columns,
    FilterSchema: filterSchema,
    FormSchema: formSchema,
    service: service,
    onFormStateChange
  });
  useImperativeHandle(ref, () => {
    Object.assign(crud.filter, {
      setOptions: setFilterOptions,
    })
    Object.assign(crud.form, {
      setOptions: setFormOptions,
    })
    return crud
  })
  useEffect(() => {
    crud.list.doFetch();
  }, []);
  const relatedOptionKey = getRelatedOptionField(schema);
  const relatedSchemaKey = getRelatedSchemaTrigger(schema);
  const computedKey = getComputedField(schema);
  useEffect(() => {
    getOptions({}, schema, "onFilterMount")
      .then((p) => {
        setFilterOptions(p);
      })
      .catch((e) => {
        message.error(e.message || "获取下拉参数失败！");
      });
  }, []);
  useEffect(() => {
    if (!crud.modal.visible) return;
    getOptions({}, schema, "onFormMount")
      .then((p) => {
        setFormOptions(p);
        useFirstOption({
          form: crud.form,
          options: p,
          schema
        })
      })
      .catch((e) => {
        message.error(e.message || "获取下拉参数失败！");
      });
  }, [formMode, crud.modal.visible]);
  computedKey.map((key) => {
    useEffect(() => {
      // if (crud.form.fields[key] === undefined) return;
      if (!Object.keys(crud.form.fields).length) return;
      getComputed(
        crud.form.fields,
        schema,
        `onChange:${key}`,
        formOptionsRef.current
      )
        .then((p) => {
          crud.form.setFields({
            ...crud.form.fields,
            ...p,
          });
        })
        .catch((e) => {
          console.log(e);
          message.error(e.message || "获取计算参数失败！");
        });
    }, [crud.form.fields[key]]);
  });
  relatedSchemaKey.map((key) => {
    useEffect(() => {
      if (crud.form.fields[key] === undefined) return;
      getFiltedSchema(crud.form.fields, schema, `onChange:${key}`)
        .then((p) => {
          setFormSchema(
            getFormSchema(
              p,
              formOptionsRef.current,
              formMode === "detail" ? true : false
            )
          );
        })
        .catch((e) => {
          console.log(e);
          message.error(e.message || "获取表单参数失败！");
        });
    }, [crud.form.fields[key]]);
  });
  relatedOptionKey.map((key) => {
    useEffect(() => {
      //关闭表单触发
      if (!Object.keys(crud.form.fields).length) {
        setFormOptions({});
        return;
      }
      getOptions(crud.form.fields, schema, `onChange:${key}`)
        .then((p) => {
          setFormOptions((pre) => ({ ...pre, ...p }));
          //清除联动字段
          removeValueOnOptionChanged({
            form: crud.form,
            options: p
          })
          useFirstOption({
            form: crud.form,
            schema: schema,
            options: p
          })
        })
        .catch((e) => {
          message.error(e.message || "获取下拉参数失败！");
        });
    }, [crud.form.fields[key]]);
  });
  relatedOptionKey.map((key) => {
    useEffect(() => {
      if (!Object.keys(crud.filter.tempValue).length) {
        // setFilterOptions({});
        return;
      }
      getOptions(crud.filter.tempValue, schema, `onChange:${key}`)
        .then((p) => {
          setFilterOptions((pre) => ({ ...pre, ...p }));
        })
        .catch((e) => {
          message.error(e.message || "获取下拉参数失败！");
        });
    }, [crud.filter.tempValue[key]]);
  });  
  useEffect(() => {
    setFormSchema((sch) => {
      Object.keys(formOptions).map((key) => {
        if (sch[key]) {
          sch[key].options = formOptions[key];
        }
      });
      return { ...sch };
    });
  }, [formOptions]);
  const { filter } = crud;
  const downloadUrl = api.download
    ? getDownLoadUrl(api.download, {
        ...filter.fields,
      })
    : "";

  return (
    <Crud
      className={"TUI-AdvancedCrud"}
      modal={crud.modal}
      form={crud.form}
      FormSchema={crud.FormSchema}
      filter={crud.filter}
      FilterSchema={crud.FilterSchema}
      list={crud.list}
      ListSchema={crud.ListSchema}
      listProps={{ rowSelection: null, scrollX: true, rowKey: rowKey }}
      modalProps={{
        title: modalTitle,
        footer: modalFooter,
        wrapClassName: modalWrapClassName,
        ...modalProps
      }}
      setFormMode={setFormMode}
      query={service.query}
      formOptions={formOptions}
      filterOptions={filterOptions}
      Table={Table}
      Form={Form}
      Modal={Modal}
      Filter={Filter}
      {...rest}
    >
      <NullWhenNoChildren key={
            Object.keys(crud.FilterSchema).length
              ? "CRUD-FILTER-INLINE"
              : "CRUD-FILTER-BOTTOM"
          } 
        wrap={
        <div
          className="TUI-Crud-Toolbox"
        ></div>
      }>
        <Button
          type="primary"
          active={true}
          auth={api.add ? auth.add : -9999}
          onClick={api.add && api.add.onClick ? api.add.onClick : async () => {
            const fn = (red) => {
              let formSchema = getFormSchema(schema, formOptions, false);
              setFormSchema(formSchema);
              setFormMode("add");
              crud.form.setFields({
                ...formatRes(getDefaultFields(schema, red), schema),
                ...red,
              });
              crud.modal.show();
            };
            if (typeof hookBeforeAdd === "function") {
              try {
                let rec = await hookBeforeAdd({
                  crud,
                  formMode,
                  formOptions,
                });
                fn(rec);
              } catch (e) {
                message.error(e.message);
              }
            } else {
              fn();
            }
          }}
        >
          {api.add && api.add.name ? api.add.name : "新增"}
        </Button>
        <Button
          icon={"download"}
          href={downloadUrl}
          active={true}
          auth={api.download ? auth.download : -9999}
          target="blank"
        >
          导出数据
        </Button>
        {
          React.Children.map(children, (child) => {
            if (!child) return child;
            return (child.key === "CRUD-FILTER-BOTTOM" || child.key === "CRUD-FILTER-INLINE") ? child : null;
          })
        }
      </NullWhenNoChildren>
      {
        React.Children.map(children, (child) => {
          if (!child) return child;
          return (child.key !== "CRUD-FILTER-BOTTOM" && child.key !== "CRUD-FILTER-INLINE") ? child : null;
        })
      }
    </Crud>
  );
};
let AdvancedCrud = forwardRef(AdvancedCrudCom)
AdvancedCrud.addComponent = addComponent;
AdvancedCrud.getComponent = getComponent;
AdvancedCrud.addRule = addRule;
AdvancedCrud.getRule = getRule;
AdvancedCrud.addReqTransformer = addReqTransformer;
AdvancedCrud.addResTransformer = addResTransformer;
AdvancedCrud.getReqTransformer = getReqTransformer;
AdvancedCrud.getResTransformer = getResTransformer;
export default AdvancedCrud;